import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import { Col, Row } from "reactstrap";
import { SocialPost } from "../../../../cores/socialPost/interfaces/api/get-social-posts";
import { DropdownOptions } from "./DropdownOptions";
import { MediaPreview } from "./MediaPreview";

interface Props {
  post: SocialPost;
  onDelete: () => void;
  onEdit: () => void;
}

/** Vista previa genérica (p. ej. TikTok u otra red sin mock específico). */
export const GenericSocialPostPreview = (props: Props) => {
  const { post, onEdit, onDelete } = props;
  const {
    publisherName,
    publisherAvatarUrl,
    text,
    postAt,
    scheduleDate,
    status,
    type,
  } = post.post;

  const when = postAt
    ? moment(postAt).format("DD MMM YYYY · HH:mm")
    : scheduleDate
    ? moment(scheduleDate).format("DD MMM YYYY · HH:mm")
    : "—";

  return (
    <>
      <Row className="align-items-center px-2 py-2 border-bottom">
        <Col xs="8" className="d-flex align-items-center">
          {publisherAvatarUrl ? (
            <img
              src={publisherAvatarUrl}
              alt=""
              className="rounded-circle mr-2"
              style={{ width: 40, height: 40, objectFit: "cover" }}
            />
          ) : null}
          <div>
            <div className="font-weight-bold">{publisherName || "—"}</div>
            <div className="text-muted small">{when}</div>
          </div>
        </Col>
        <Col xs="4" className="d-flex justify-content-end">
          {status === 0 && (
            <DropdownOptions onEdit={onEdit} onDelete={onDelete}>
              <FontAwesomeIcon className="pointer" icon={["fas", "ellipsis-h"]} />
            </DropdownOptions>
          )}
        </Col>
      </Row>
      <div className="px-3 py-2">
        <p className="mb-2" style={{ whiteSpace: "pre-wrap" }}>
          {text || "—"}
        </p>
        {post.media && post.media.length > 0 && (
          <MediaPreview className="w-100 rounded" type={type} media={post.media} />
        )}
      </div>
    </>
  );
};
